import apiClient from '../axios/client.js';

/**
 * Orders API service
 * Handles all orders-related API calls
 */
class OrdersApiService {
  /**
   * Get orders list with pagination and filtering
   * @param {number} limit - Number of orders to return
   * @param {number} offset - Offset for pagination
   * @returns {Promise<Object>} Orders data with pagination info
   */
  async getOrders(limit = 250, offset = 0) {
    try {
      const response = await apiClient.get('/orders', {
        params: { limit, offset }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching orders:', error);
      throw error;
    }
  }

  /**
   * Update order operation status (drag & drop)
   * @param {Object} data - Update data
   * @param {number} data.pedidoId - Order ID
   * @param {string} data.tenantId - Tenant ID
   * @param {string} data.status - New status
   * @param {number} data.position - Position in column
   * @returns {Promise<void>}
   */
  async updateOrderStatus(data) {
    try {
      await apiClient.post('/orders/status', data);
    } catch (error) {
      console.error('Error updating order status:', error);
      throw error;
    }
  }

  /**
   * Update order checkbox status (separacao/producao)
   * @param {Object} data - Update data
   * @param {number} data.pedidoId - Order ID
   * @param {string} data.tenantId - Tenant ID
   * @param {string} data.statusType - Status type (separacao/producao)
   * @param {boolean} data.isChecked - Checkbox state
   * @returns {Promise<void>}
   */
  async updateOrderCheckbox(data) {
    try {
      await apiClient.post('/orders/checkbox', data);
    } catch (error) {
      console.error('Error updating order checkbox:', error);
      throw error;
    }
  }

  /**
   * Get detailed order information
   * @param {number} pedidoId - Order ID
   * @param {string} tenantId - Tenant ID
   * @returns {Promise<Object>} Detailed order data
   */
  async getOrderDetails(pedidoId, tenantId) {
    try {
      const response = await apiClient.get(`/orders/${pedidoId}`, {
        params: { tenantId }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching order details:', error);
      throw error;
    }
  }

  /**
   * Save order item changes
   * @param {Object} data - Save data
   * @param {number} data.pedidoId - Order ID
   * @param {string} data.tenantId - Tenant ID
   * @param {Array} data.changes - Array of item changes
   * @returns {Promise<void>}
   */
  async saveOrderChanges(data) {
    try {
      await apiClient.post('/orders/changes', data);
    } catch (error) {
      console.error('Error saving order changes:', error);
      throw error;
    }
  }
}

const ordersApiService = new OrdersApiService();
export default ordersApiService;
